import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Novedad, RolPlataforma } from '../../../../core/models/novedades.models';
import { NovedadesService } from '../../../../core/services/novedades.service';
import { formatNotificationDate } from '../../../../core/utils/date-format.util';

@Component({
  selector: 'app-principal-dashboard-panel',
  imports: [CommonModule],
  templateUrl: './principal-dashboard-panel.html',
  styleUrl: './principal-dashboard-panel.css',
})
export class PrincipalDashboardPanel implements OnInit, OnChanges {
  @Input({ required: true }) rolSeleccionado: RolPlataforma = 'administrador_anid';

  novedades: Novedad[] = [];
  paginaActual = 1;
  readonly pageSize = 3;

  constructor(private readonly novedadesService: NovedadesService) {}

  ngOnInit(): void {
    this.cargarNovedades();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rolSeleccionado'] && !changes['rolSeleccionado'].firstChange) {
      this.paginaActual = 1;
      this.cargarNovedades();
    }
  }

  cargarNovedades(): void {
    this.novedadesService.getNovedadesInstitucionales(this.rolSeleccionado).subscribe((data) => {
      this.novedades = data || [];
    });
  }

  get totalPaginas(): number {
    return Math.ceil(this.novedades.length / this.pageSize) || 1;
  }

  get novedadesPaginadas(): Novedad[] {
    const start = (this.paginaActual - 1) * this.pageSize;
    return this.novedades.slice(start, start + this.pageSize);
  }

  get paginasArray(): number[] {
    return Array.from({ length: this.totalPaginas }, (_, i) => i + 1);
  }

  cambiarPagina(p: number): void {
    if (p >= 1 && p <= this.totalPaginas) {
      this.paginaActual = p;
    }
  }

  formatoFecha(fecha?: string): string {
    return formatNotificationDate(fecha);
  }

  colorTipo(tipo?: string): 'blue' | 'green' | 'orange' {
    if (tipo === 'completado') return 'green';
    if (tipo === 'pendiente' || tipo === 'alerta') return 'orange';
    return 'blue';
  }

  etiquetaTipo(novedad: Novedad): string {
    return 'Etiqueta';
  }
}
